import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';
import Select from '../../../components/ui/Select';

const EmergencyAssessment = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    company: '',
    phone: '',
    email: '',
    urgency: '',
    issue: ''
  });

  const urgencyOptions = [
    { value: 'critical', label: 'Critical - Complete Network Failure' },
    { value: 'high', label: 'High - Severe Performance Issues' },
    { value: 'medium', label: 'Medium - Intermittent Problems' },
    { value: 'planning', label: 'Planning - Proactive Assessment' }
  ];

  const handleSubmit = (e) => {
    e?.preventDefault();
    onSubmit(formData);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-brand-strong max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-6 border-b border-border">
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-3">
              <div className="w-10 h-10 bg-error rounded-full flex items-center justify-center">
                <Icon name="AlertTriangle" size={20} className="text-white" />
              </div>
              <div>
                <h2 className="text-xl font-semibold text-text-primary">Emergency Assessment</h2>
                <p className="text-sm text-text-secondary">Fast-track consultation for urgent network issues</p>
              </div>
            </div>
            <Button variant="ghost" size="icon" onClick={onClose}>
              <Icon name="X" size={20} />
            </Button>
          </div>
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-6">
          <div className="bg-error/10 border border-error/20 rounded-lg p-4">
            <div className="flex items-start space-x-2">
              <Icon name="Clock" size={16} className="text-error mt-0.5" />
              <div>
                <p className="text-sm font-medium text-error">Priority Response</p>
                <p className="text-xs text-text-secondary mt-1">
                  Our technical specialists will contact you within 30 minutes during business hours
                </p>
              </div>
            </div>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <Input
              label="Full Name"
              type="text"
              required
              value={formData?.name}
              onChange={(e) => handleInputChange('name', e?.target?.value)}
              placeholder="Enter your full name"
            />
            
            <Input
              label="Company Name"
              type="text"
              required
              value={formData?.company}
              onChange={(e) => handleInputChange('company', e?.target?.value)}
              placeholder="Enter company name"
            />
            
            <Input
              label="Phone Number"
              type="tel"
              required
              value={formData?.phone}
              onChange={(e) => handleInputChange('phone', e?.target?.value)}
              placeholder="01483 343 064"
            />
            
            <Input
              label="Email Address"
              type="email"
              required
              value={formData?.email}
              onChange={(e) => handleInputChange('email', e?.target?.value)}
              placeholder="your.email@company.com"
            />
          </div>
          
          <Select
            label="Issue Urgency Level"
            options={urgencyOptions}
            value={formData?.urgency}
            onChange={(value) => handleInputChange('urgency', value)}
            required
            placeholder="Select urgency level"
          />
          
          <div>
            <label className="block text-sm font-medium text-text-primary mb-2">
              Describe Your Network Issue
            </label>
            <textarea
              value={formData?.issue}
              onChange={(e) => handleInputChange('issue', e?.target?.value)}
              placeholder="Please describe the network issues you're experiencing, including when they started and how they're affecting your business operations..."
              rows={4}
              required
              className="w-full px-3 py-2 border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-ring focus:border-transparent resize-none"
            />
          </div>
          
          <div className="flex items-center justify-between pt-4 border-t border-border">
            <div className="flex items-center space-x-2 text-sm text-text-secondary">
              <Icon name="Shield" size={16} />
              <span>Your information is secure and confidential</span>
            </div>
            
            <div className="flex space-x-3">
              <Button variant="outline" onClick={onClose}>
                Cancel
              </Button>
              <Button 
                type="submit" 
                variant="default"
                iconName="Send"
                iconPosition="right"
                className="cta-primary"
              >
                Request Emergency Consultation
              </Button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmergencyAssessment;